import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import { tutorialArticles } from '../data/articles';

const Tutorials: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Tutorials - ClipThis"
        description="Step-by-step guides for TikTok, YouTube Shorts, Instagram Reels, and AI highlight workflows."
        url="/tutorials"
      />
      <BreadcrumbSchema items={[{ name: 'Tutorials', path: '/tutorials' }]} />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Tutorials</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Learn faster, publish more</h1>
          <div className="grid md:grid-cols-2 gap-6">
            {tutorialArticles.map((article) => (
              <article key={article.slug} className="p-6 rounded-2xl border border-gray-200 bg-gray-50 flex flex-col">
                <div className="text-xs text-gray-500 uppercase tracking-[0.2em] mb-2">{article.published}</div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">{article.title}</h2>
                <p className="text-gray-600 flex-1">{article.summary}</p>
                <div className="flex items-center justify-between text-sm text-gray-500 mt-4">
                  <span>{article.readingTime}</span>
                  <Link to={`/tutorials/${article.slug}`} className="text-red-600 font-medium hover:underline">
                    Read guide →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Tutorials;

